import React from "react";

function PencilShapeItem({
  mainTitle,
  mainTitleColor = "white",
  image,
  subTitle,
  text,
}) {
  return (
    <div className="pencil-shape-item">
      {mainTitle && (
        <h4
          className="pencil-shape-item__main-title"
          style={{ color: mainTitleColor }}
        >
          {mainTitle}
        </h4>
      )}
      {image && <img src={image} alt="" className="pencil-shape-item__image" />}
      {subTitle && <h5 className="pencil-shape-item__subtitle">{subTitle}</h5>}
      {text && <p className="pencil-shape-item__text">{text}</p>}
    </div>
  );
}

export default PencilShapeItem;
